// extracted by mini-css-extract-plugin
export default {"container":"cCDcUh_fq","loadingContainer":"cjctyDpVX","textContainer":"ck4twm_GX","readOnlyContainer":"cbQYyeEKr"};